import {Component, OnInit, ElementRef, SimpleChanges, Input, OnChanges} from '@angular/core';
import {UserService} from 'src/app/services/user/user.service';
import {Router} from '@angular/router';
import {LoadingService} from 'src/app/services/loading/loading.service';
import AppConstants, {agency_auditor_role} from 'src/app/shared/common-components/AppConstants';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-enterprise';
import {takeWhile} from 'rxjs/operators';
import {User} from 'src/app/services/user/user';
import {BehaviorSubject} from 'rxjs';
import {AlertService} from 'src/app/services/alert/alert.service';
import {ShipmentReviewService} from '../../services/shipment-review/shipment-review.service';
import _ from 'lodash';

@Component({
    selector: 'app-frt-shipment-review-results',
    templateUrl: './frt-shipment-review-results.component.html',
    styleUrls: ['./frt-shipment-review-results.component.css'],
    standalone: false
})
export class FrtShipmentReviewResultsComponent implements OnInit, OnChanges {

  @Input() status: string;
  @Input() userPrefList: any;
  @Input() shipmentReviewList: any = [];
  @Input() showBody = false;
  @Input() screenName: any;
  @Input() shipmentType: any;
  columnDefs: any;
  currentUser: User | any;
  private observer$ = new BehaviorSubject(true);
  private gridApi;
  userPrefBtnText: any;
  shipmentReviewGridOptions: GridOptions = this.initializeGridOptions();
  public tooltipShowDelay = 0;

  constructor(private userService: UserService,
              private loader: LoadingService,
              private alertService: AlertService,
              private shipmentReviewService: ShipmentReviewService,
              private el: ElementRef,
              private router: Router) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loader.show();
    this.userPrefBtnText = 'Set data view preferences';
    this.updateColumnDefs();
    if (changes && AppConstants.isNotNullCondition(changes.status)) {
      this.updateColumnDefs();
      this.loader.hide();
    }
    if (Object.keys(changes) && Object.keys(changes).length === 1) {
      this.loader.hide();
    }
  }

  ngOnInit(): void {
    this.loader.show();
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(currentUser => {
        this.currentUser = currentUser;
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.info('unable to get current user details');
      });
  }

  updateColumnDefs() {
    this.columnDefs = this.getShipmentReviewColumnDefs();
    this.showHideColumnsBasedOnPrefs();
  }

  showHideColumnsBasedOnPrefs() {
    if (this.userPrefList && this.userPrefList.length > 0) {
      this.columnDefs.forEach(col => {
        this.userPrefList.forEach(pref => {
          if (pref.field === col.field) {
            col.hide = (!pref.isVisible) ? true : false;
          }
        });
      });
    }
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agNumberColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      rowHeight: 40,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      onGridReady: params => {
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  getShipmentReviewColumnDefs(): (ColDef | ColGroupDef)[] {
    console.log('inside  method getShipmentReviewColumnDefs');
    return [
      <ColDef>
        {
          headerName: 'Shipment ID',
          field: 'shipmentId',
          filter: 'agNumberColumnFilter',
          width: 100,
          cellRenderer: params => {
            if (null != params.data.bolNumber || params.data.bolNumber || this.checkUserRole(agency_auditor_role)) {
              return params.data.shipmentId;
            }
            return '<a tabindex="0">' + params.data.shipmentId + '</a>';
          },
          onCellClicked: event => !this.checkUserRole(agency_auditor_role) ? this.onShipmentIdClicked(event.data) : null

        },
      {
        headerName: 'BOL Number',
        field: 'bolNumber',
        width: 100,
        filter: 'agTextColumnFilter',
        cellRenderer: params => {
          if ((null != params.data.bolNumber || params.data.bolNumber) && !this.checkUserRole(agency_auditor_role)) {
            return '<a tabindex="0">' + params.data.bolNumber + '</a>';
          }
          return params.data.bolNumber;
        },
        onCellClicked: event => !this.checkUserRole(agency_auditor_role) ? this.onShipmentIdClicked(event.data) : null
      },
      // agencyShipmentIdNo
      {
        headerName: 'Agency Shipment Id',
        field: 'agencyShipmentIdNo',
        width: 100,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'SCAC',
        field: 'scac',
        width: 100,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'TSP',
        field: 'carrierName',
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Agency-Bureau Name',
        field: 'agencyBureauName',
        filter: 'agTextColumnFilter',
        width: 100
      },
      {
        headerName: 'Origin',
        field: 'origin',
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Destination',
        field: 'destination',
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Move Date',
        field: 'moveDate',
        width: 120,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Status',
        width: 130,
        field: 'bookingStatus',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Total Cost',
        width: 90,
        field: 'totalCost',
        filter: 'agTextColumnFilter',
        headerTooltip: 'Total Cost includes Fuel Surcharge and Accessorials Cost',
        valueFormatter: this.shipmentReviewService.formatNumber
      },
      {
        headerName: 'Total Packages',
        field: 'totalPackages',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Shipment Description',
        field: 'shipmentDescription',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Shipment Declared Value',
        field: 'shipmentDeclaredValue',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Fuel SRCHG',
        width: 90,
        field: 'fuelSurchargeCost',
        filter: 'agTextColumnFilter',
        valueFormatter: this.shipmentReviewService.formatNumber
      },
      {
        headerName: 'AF Calculated',
        width: 90,
        field: 'estimatedIffDue',
        filter: 'agTextColumnFilter',
        headerTooltip: 'IFF does not include Fuel Surcharge Cost' ,
        valueFormatter: this.shipmentReviewService.formatNumber

      },
      {
        headerName: 'Weight',
        width: 90,
        field: 'weight',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Miles',
        width: 90,
        field: 'miles',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'OTO',
        field: 'oneTimeOnly',
        width: 80,
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Actual Delivery Date',
        field: 'actualDeliveryDate',
        width: 120,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Sent To Syncada',
        field: 'sentToSyncada',
        width: 100,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Date Sent to Syncada',
        field: 'dateSentToSyncada',
        width: 120,
        filter: 'agDateColumnFilter'
      },
      {
        headerName: 'Smart Way',
        field: 'smartWayScore',
        filter: 'agTextColumnFilter',
        minWidth: 80,
        maxWidth: 100,
        cellRenderer: params =>
          params.data.smartWayScore === 1
            ? '<svg class="usa-icon define-text-green define-size-leaf" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#eco"></use></svg>'
            : ''
      },
      {
        headerName: 'Socio Econ Ind',
        field: 'ses',
        filter: 'agTextColumnFilter'
      }
    ];
  }

  onShipmentIdClicked(shipmentReviewListSelectedItem: any) {
    this.router.navigate(['/', 'shipmentcontrolreview'],
      {queryParams: {bookshipmentid: shipmentReviewListSelectedItem.shipmentId, shipmentType: this.shipmentType}});
  }

  updateListPrefs(listPref: any) {
    this.userPrefList = listPref;
    this.updateColumnDefs();
  }

  gotoUserPrefs() {
    this.showBody = true;

  }

  /**
   *
   * @param: roles
   * @returns: {boolean}
   */
  checkUserRole(roles?) {
    if (this.currentUser) {
      const userRoles = _.map(this.currentUser.roles, x => x.role);
      if (userRoles && userRoles.length > 0) {
        return _.includes(userRoles, roles);
      }
    }
  }

  closeUserPrefs() {
    this.showBody = false;
  }

}
